import dayjs from "dayjs"

const mixin = {
  methods: {
    getDiasSemanaReserva(reserva) {
      let dias_semana = reserva.dias.map((e) => {
        if (e.dia === "Domingo") return 0
        if (e.dia === "Segunda-feira") return 1
        if (e.dia === "Terça-feira") return 2
        if (e.dia === "Quarta-feira") return 3
        if (e.dia === "Quinta-feira") return 4
        if (e.dia === "Sexta-feira") return 5
        if (e.dia === "Sábado") return 6
      })
      return dias_semana
    },
    formataData(novaData) {
      return dayjs(novaData).format("DD/MM/YYYY")
    },
  },
}

export default mixin
